import * as types from './types.action';
import {reset} from 'redux-form';
import {SentryHelper} from '../helpers/sentry.helper';

import tableBookingApi from '../api/tableBooking.api';

const getBookingConfigSuccess = config => {
  return {
    type: types.GET_TABLE_BOOKING_CONFIG_SUCCESS,
    config
  };
};

export const getBookingConfig = restaurantCode => dispatch => {

  return tableBookingApi.getBookingConfig(restaurantCode)
    .then(config => dispatch(getBookingConfigSuccess(config)))
    .catch(error => {
      SentryHelper.logException(new Error(error), {
          restaurantCode,
          error: error.response && error.response.data
        },
        { method: 'getBookingConfig' }
      );

      throw error;
    });
};

const setBookingSuccess = reservation => {
  return {
    type: types.SET_TABLE_BOOKING_SUCCESS,
    reservation
  };
};

export const submitBooking = (restaurantCode, restaurantId, date, values) => dispatch => {
  return tableBookingApi.submit(restaurantCode, restaurantId, date, values)
    .then(data => {
      dispatch(setBookingSuccess(data.reservation));
      dispatch(reset('tableBookingForm'));
    })
    .catch(error => {
        SentryHelper.logException(new Error(error), {
            restaurantCode,
            restaurantId,
            date,
            values,
            error: error.response && error.response.data
          },
          { method: 'submitBooking' }
        );

      throw (error);
    });
};

export const resetReservation = () => {
  return {
    type: types.SET_TABLE_BOOKING_SUCCESS,
    reservation: null
  };
};



// WEBPACK FOOTER //
// ./actions/tableBooking.action.js